<script setup lang="ts">
import { Auth, Notices, useConnection } from '@evac/shared'
import { watch } from 'vue'
import { RouterView } from 'vue-router'

import { loadDashboardData, refetchOnReconnect } from '@/router'
import { resetLoadedEntities } from '@/router/config'

// Route guards fetch resources at app mount — before login completes — so their first
// attempt 401s and is swallowed. Re-fetch once authentication succeeds, otherwise the
// dashboard stays empty (no permission to read resources before login).
const { isAuthenticated } = Auth.useState()
watch(isAuthenticated, (authed, wasAuthed) => {
  if (!authed || wasAuthed) return
  resetLoadedEntities()
  loadDashboardData(true)
})
refetchOnReconnect(useConnection().isOnline, isAuthenticated)
</script>

<template>
  <Auth.Wall>
    <RouterView />
    <template #login>
      <Auth.LoginForm class="place-self-center" />
    </template>
  </Auth.Wall>
  <Notices />
</template>
